import { render } from "./LbrxCalendarWeek.vue?vue&type=template&id=8ee204e8"
import script from "./LbrxCalendarWeek.vue?vue&type=script&lang=js"
export * from "./LbrxCalendarWeek.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__